module.exports = __webpack_public_path__ + "static/media/helpandsupportSelectedIcon.ecb66043.svg";